var render = function () {
  var _vm$sidebarItem$_vm$a, _vm$sidebarItem$_vm$a2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content flex w-full h-full"
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "navbar",
    class: {
      'shrink-menu': !_vm.expandedMenu
    }
  }, [_c('TheSidebar', {
    attrs: {
      "sidebarStatus": _vm.expandedMenu
    }
  })], 1) : _c('div', {
    staticClass: "mobile-sidebar",
    class: {
      'expand-menu': !_vm.expandedMenu
    }
  }, [_c('TheMobileSidebar', {
    attrs: {
      "sidebarStatus": _vm.expandedMenu
    }
  })], 1), _vm.isMobile && !_vm.expandedMenu ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function click($event) {
        return _vm.toggleMenu();
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "content_wrapper w-full"
  }, [_c('div', {
    staticClass: "header",
    class: {
      'shrink-header': !_vm.expandedMenu && !this.isMobile
    }
  }, [_c('TheHeader'), _c('div', {
    staticClass: "text-left flex px-3 py-3 bg-white items-center"
  }, [_c('div', {
    staticClass: "texl-lg font-bold py-1 border-r-2 border-neutral-600 leading-none pr-2"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _c('router-link', {
    staticClass: "pl-2 text-xs text-neutral-500 pr-2",
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Dashboard")]), _vm.$route.name !== 'Dashboard' ? _c('span', {
    staticClass: "inline-block text-xs text-neutral-700"
  }, [_vm._v("/ " + _vm._s(_vm.$route.name))]) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "panel min-h-contain flex-col"
  }, [_c('div', {
    staticClass: "w-full px-10 py-6 mdmax:w-full mdmax:mx-0 mdmax:px-4 mdmax:py-4"
  }, [_c('router-view')], 1)]), _c('div', {
    staticClass: "bg-neutral-600 py-4"
  }, [_c('div', {
    staticClass: "px-7 mx-auto flex justify-between items-center mdmax:px-7 mdmax:flex-col mdmax:gap-2"
  }, [_c('p', {
    staticClass: "text-white text-xs"
  }, [_vm._v("© " + _vm._s(_vm.year) + " Linknau. All Rights Reserved.")]), _vm._m(0)])]), _c('Toast'), _c('Modal', {
    attrs: {
      "modalVisible": _vm.isAddressModalVisible,
      "width": "600px",
      "id": "address-modal"
    },
    on: {
      "close": function close($event) {
        return _vm.toggleModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('AddAddress', {
    on: {
      "close": function close($event) {
        return _vm.toggleModal();
      },
      "refresh": _vm.refreshAddressList
    }
  })], 1)], 2)], 1), _c('div', {
    staticClass: "user-sidebar",
    class: [_vm.visibleProfileScreen ? 'open' : 'close']
  }, [_c('div', {
    staticClass: "flex gap-2 p-3 items-center sticky"
  }, [_c('span', {
    staticClass: "inline-block cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.toggleUserSidebar();
      }
    }
  }, [_c('Close')], 1), _vm.activeComponent ? _c('p', {
    staticClass: "text-lg font-bold"
  }, [_vm._v(_vm._s((_vm$sidebarItem$_vm$a = _vm.sidebarItem[_vm.activeComponent]) === null || _vm$sidebarItem$_vm$a === void 0 ? void 0 : _vm$sidebarItem$_vm$a.title))]) : _vm._e()]), _vm.activeComponent ? _c((_vm$sidebarItem$_vm$a2 = _vm.sidebarItem[_vm.activeComponent]) === null || _vm$sidebarItem$_vm$a2 === void 0 ? void 0 : _vm$sidebarItem$_vm$a2.component, {
    tag: "component",
    on: {
      "dismiss": function dismiss($event) {
        return _vm.toggleUserSidebar();
      }
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "sidebar-backdrop cursor-pointer",
    class: {
      open: _vm.visibleProfileScreen
    },
    on: {
      "click": function click($event) {
        return _vm.toggleUserSidebar();
      }
    }
  })]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex gap-6 items-center"
  }, [_c('a', {
    staticClass: "text-white text-xs",
    attrs: {
      "href": "https://www.linknau.id/syarat-ketentuan",
      "target": "_blank"
    }
  }, [_vm._v("Terms & Condition")]), _c('a', {
    staticClass: "text-white text-xs",
    attrs: {
      "href": "https://www.linknau.id/kebijakan-privasi",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])]);
}]

export { render, staticRenderFns }